/**
 * Created by pedrosantos on 10/03/14.
 */

"use strict";

(function () {

    $.widget('khis.FileUploadHelper', {
        options: {
            fileInputContainerId: 'files',
            fileInputId: 'fileupload',
            buttonLabel: '',
            dropZoneLabel: '',
            docType: 1, //other
            url: '/document/add_document',
            originType: null,
            originId: null,
            multipleAttachements: true,
            associateAttachementUrl: ''
        },
        customFile: 0,
        filesData: {},
        pendingAttachments: [],
        fileSuccess: 0,
        fileError: 0,
        customFieldId: 0,
        container: null,
        fileInput: null,
        docType: 1, //other
        _create: function () {
            this.element.empty();

            this.element
                .addClass('file_helper')
                .append($('<span class="fileinput-button"><span>' + this.options.buttonLabel + '</span><input id="' + this.options.fileInputId + '" type="file" name="files[]" style="width: 115px; height: 30px; font-size: 30px;" multiple></span>'))
                .append($('<div class="dropzone" style="height: 50px; margin-top: 8px; border: 2px dashed rgb(169, 217, 224); padding: 0 8px; font-style: italic; line-height: 50px;"><img src="/assets/arrow_dropzone.gif"><span style="margin-left: 8px; color: #CCCCCC; font-weight: bold;            ">' + this.options.dropZoneLabel + '</span></div>'))
                .append($('<div id="' + this.options.fileInputContainerId + '" class="files" style="margin-top: 8px;"></div>'));

            this.fileInput = this.element.find('input[type=file]');
        },
        _init: function () {
            this.customFile = 0;
            this.filesData = {};
            this.pendingAttachments = [];
            this.fileSuccess = 0;
            this.fileError = 0;
            this.customFieldId = 0;
            this.container = null;

            this.fileInput.fileupload({
                url: this.options.url,
                dataType: 'json',
                autoUpload: false,
                dropZone: this.element.find('.dropzone'),
                docType: this.options.docType,
                originType: this.options.originType,
                messages: {
                    maxFileSize: Hades.getUploadSizeError().replace('#MAX_VALUE#', Hades.getMaxUploadSize())
                },
                //acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
                maxFileSize: parseInt(Hades.getMaxUploadSize() * 1000000),
                //maxChunkSize: 512000,
                // Enable image resizing, except for Android and Opera,
                // which actually support image resizing, but fail to
                // send Blob objects via XHR requests:
                disableImageResize: /Android(?!.*Chrome)|Opera/
                    .test(window.navigator.userAgent),
                previewMaxWidth: 100,
                previewMaxHeight: 100,
                previewCrop: true
            }).prop('disabled', !$.support.fileInput)
                .parent().addClass($.support.fileInput ? undefined : 'disabled');

            this._on({
                'fileuploadadd input[type=file]': function (e, data) {
                    data.customFieldId = this.customFieldId++;

                    this.filesData[data.customFieldId] = data;

                    data.context = $('<table class="file_ct" data-row="' + data.customFieldId + '"/>').appendTo($('#' + this.options.fileInputContainerId));

                    var that = this;

                    $.each(data.files, function (index, file) {
                        var title = file.name;

                        if(!title){
                            title = that.customFile++;
                        }

                        var node = $('<tr/>')
                            .append($('<td class="file_preview"></td>'))
                            .append($('<td class="text_line"></td>')
                                .append($('<input class="float_left" type="text" value="'+title+'" style="display: none;">'))
                                .append($('<span class="float_left txt_link"/>').text(title).attr('title', title))
                                .append($('<span class="float_left ui-icon ui-icon-pencil" style="cursor: pointer;"></span>'))
                                .append($('<span class="float_left ui-icon ui-icon-check" style="cursor: pointer; display: none;"></span>'))
                            )
                            .append($('<td class="file_actions"></td>'));

                        node.appendTo(data.context);

                        var progressBar = $('<tr><td colspan="3"><div class="custom_progress_bar"><div class="progress_bar_inner"></div></div></td></tr>');
                        progressBar.appendTo(data.context);
                    });

                    data.context.find('td.text_line span.txt_link').click(function () {
                        var _preview = $($(this).closest('tr').find('td.file_preview'));

                        if (_preview && _preview.children().length > 0) {
                            if (_preview.is(':visible')) {
                                _preview.hide();
                            } else {
                                _preview.show();
                            }
                        }
                    });

                    data.context.find('td.text_line .ui-icon-pencil').click(function () {
                        $(this).closest('.text_line').find('.txt_link').hide();
                        $(this).closest('.text_line').find('input').show();
                        $(this).closest('.text_line').find('.ui-icon-pencil').hide();
                        $(this).closest('.text_line').find('.ui-icon-check').show();
                    });

                    data.context.find('td.text_line .ui-icon-check').click(function () {
                        var newVal = $(this).closest('.text_line').find('input').val();

                        if(newVal && newVal.length > 0){
                            $(this).closest('.text_line').find('.txt_link').html(newVal);
                            $(this).closest('.file_helper').FileUploadHelper('changeFilename', data.customFieldId, newVal);
                        }

                        $(this).closest('.text_line').find('input').hide();
                        $(this).closest('.text_line').find('.txt_link').show();
                        $(this).closest('.text_line').find('.ui-icon-check').hide();
                        $(this).closest('.text_line').find('.ui-icon-pencil').show();
                    });
                }
            });

            this._on({
                'fileuploadprocessalways input[type=file]': function (e, data) {
                    this.filesData[data.customFieldId] = data;

                    var index = data.index,
                        file = data.files[index],
                        node = $(data.context.children()[index]);

                    if (file.preview) {
                        node
                            .find('td.file_preview')
                            .append(file.preview);
                    }

                    if (file.error) {
                        node
                            .find('td.text_line')
                            .append('<br>')
                            .append($('<span class="text-danger"/>').text(file.error));
                    }

                    node
                        .find('td.file_actions')
                        .append($('<span class="ui-icon ui-icon-red ui-icon-close close_btn" />'));

                    node.find('td.file_actions .ui-icon-close').click(function () {
                        var _ct = $(this).closest('.file_ct');
                        _ct.closest('.file_helper').FileUploadHelper('deleteFile', data.customFieldId);
                        _ct.remove();
                    });
                }
            });

            this._on({ 
                'fileuploadprogressall input[type=file]': function (e, data) {
                    var progress = parseInt(data.loaded / data.total * 100, 10);

                    this.element.find('.custom_progress_bar.active .progress_bar_inner')
                        .css('width', progress + '%');
                }
            });

            this._on({
                'fileuploaddone input[type=file]': function (e, data) {
                    this.filesData[data.customFieldId] = data;

                    $.each(data.result.files, function (index, file) {
                        if (file.id) {
                            this.fileSuccess++;
                        } else if (file.error) {
                            var error = $('<span class="text-danger"/>').text(file.error);

                            $(data.context.find('td.text_line'))
                                .append('<br>')
                                .append(error);

                            this.fileError++;
                        }
                    });
                    debug.log('fileuploaddone', this.pendingAttachments.length);
                    if (this.pendingAttachments.length > 0) {
                        this.uploadAttachments();
                    } else {
                        if (this.fileError == 0) {

                            if(this.originId){
                                //TODO: Associate attach to origin
                                this._callback();

                            } else if (this._callback){
                                var attachs = this.getDocuments().join(',');
                                var origin_type = this.originType;

                                this._callback({success: true, origin_type: origin_type, attachments: attachs});

                            } else{
                                this.element.trigger('filesUploaded', {success: true});
                            }

                        } else {

                            if(this.originId){
                                //TODO: Associate attach to origin
                                this._callback();

                            } else if (this._callback){
                                this._callback({success: false});

                            } else{

                                this.element.trigger('filesUploaded', {success: false});
                            }

                        }
                    }
                }
            });

            this._on({
                'fileuploadfail input[type=file]': function (e, data) {
                    $.each(data.files, function (index, file) {
                        var error = $('<span class="text-danger"/>').text('File upload failed.');

                        $(data.context.find('td.text_line'))
                            .append('<br>')
                            .append(error);
                    });
                }
            });

            this._on({
                'fileuploadsubmit input[type=file]': function (e, data) {
                    if(this.filesData[data.customFieldId].files[0].customFilename){
                        data.formData = $('<input type="hidden" name="custom_filename" value="'+this.filesData[data.customFieldId].files[0].customFilename+'">').serializeArray();
                        data.formData.push({name:'doc_type', value: this.filesData[data.customFieldId].files[0].doc_type});
                        data.formData.push({name:'mimeType', value: this.filesData[data.customFieldId].files[0].type});
                    } else {
                        data.formData = null;
                        data.formData = $('<input type="hidden" name="doc_type" value="'+this.filesData[data.customFieldId].files[0].doc_type+'">').serializeArray();
                        data.formData.push({name:'mimeType', value: this.filesData[data.customFieldId].files[0].type});
                    }

                }
            });
        },
        _destroy: function () {
            this.element.empty();
        },
         _uploadAttachment: function () {
            var id = this.pendingAttachments.pop();
            // Activate current progress bar
            this.element.find('.custom_progress_bar.active').removeClass('active');

            this.element.find('table[data-row=' + id + ']').find('.progress_bar_inner').css('width', '0%');
            this.element.find('table[data-row=' + id + ']').find('.custom_progress_bar').addClass('active');

            // Start upload
            this.filesData[id].submit();
        },
        changeFilename: function(id, filename){
            this.filesData[id].files[0].customFilename = filename;
        },
        deleteFile: function(id){
            this.filesData[id].files.length = 0;

            if (this.filesData[id].result) {
                $.post('/document/delete_document', {doc_id:this.filesData[id].result.files[0].id}, null, 'json');

                delete this.filesData[id];
            } else {
                delete this.filesData[id];
            }
        },
        uploadAttachs: function(data, callback){
            //Hades.showLoading();
            this.attachParams = data;
            var attachmentsCount = this.getDocuments().length;

            if ( !this.multipleAttachements && attachmentsCount > 1) {
                bootbox.alert(GlobalTranslations['APP_LABEL.2445']); //'<%= get_translation_for 'APP_LABEL.1788' %>')

                Hades.hideLoading();

            } else {
                // if (!this.originId){
                //     this.originId = data.id;
                // }
                //Hades.showLoading();

                this.uploadAttachments(callback);

            }
        },
        uploadAttachments: function (callback) {
            this._callback = callback;
            // check if there is any pending attachments
            var _pendingAttachments = [];
            var _fileSuccess = 0;
            var _fileError = 0;

            $.each(this.filesData, function (index, file) {
                debug.log(this.filesData, file, index);
                if (file.files[0].error) {
                    _fileError++;
                } else if (file.result === undefined) {
                    _pendingAttachments.push(file.customFieldId);
                    //file.files[0].doc_type = 1;
                    file.files[0].doc_type = this.docType || 1;
                } else {
                    //file.files[0].doc_type = 1;
                    file.files[0].doc_type = this.docType || 1;
                    _fileSuccess++;
                }
            });

            this.pendingAttachments = _pendingAttachments;
            this.fileSuccess = _fileSuccess;
            this.fileError = _fileError;

            if (this.pendingAttachments.length > 0) {
                this._uploadAttachment();
            } else if (this.fileError > 0) {

                if(this.originId) {
                    //TODO: Associate attach to origin
                    this._callback();

                } else if(this._callback){

                    this._callback({success: false});

                } else {
                    this.element.trigger('filesUploaded', {success: false});
                }

            } else {

                if(this.originId){
                    //TODO: Associate attach to origin
                    this._callback();

                } else if (this._callback){
                    var attachs = this.getDocuments().join(',');
                    var origin_type = this.originType;

                    this._callback({success: true, origin_type: origin_type, attachments: attachs});

                } else{
                    this.element.trigger('filesUploaded', {success: true});
                }

            }
        },
        getDocuments: function () {
            debug.log('getDocuments', this.filesData);
            return $.map(this.filesData, function (elem, index) {
                    return elem.result === undefined ? '' : elem.result.files[0].id;
                }
            );
        }
    });

})();


